import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getSiteFromHostname } from '../utils/site';
import { buildApiUrl, API_ENDPOINTS } from '../config/api';

/**
 * Custom hook para logging de navegación
 * Solo registra errores en la navegación
 */
export const useNavigationLogger = () => {
  const location = useLocation();

  useEffect(() => {
    // Solo en producción, enviar log al servidor usando la API externa
    if (process.env.NODE_ENV === 'production') {
      const currentSite = getSiteFromHostname(window.location.hostname) || 'default';
      
      const logData = {
        pathname: location.pathname,
        search: location.search,
        hash: location.hash,
        fullUrl: window.location.href,
        site: currentSite,
        timestamp: new Date().toISOString()
      };

      const apiUrl = buildApiUrl(API_ENDPOINTS.LOG_NAVIGATION);
      fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(logData)
      }).catch(error => {
        // Solo mostrar errores en consola
        console.error('Error enviando log de navegación al servidor:', error);
      });
    }
  }, [location]);

  return null;
};

export default useNavigationLogger;
